// BlogList.jsx
import React, { useEffect, useState } from 'react';
import { Button, Table, Box, Typography, Select, MenuItem } from "@mui/material"
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link, useNavigate } from 'react-router-dom';
import { MdOutlineArrowLeft, MdOutlineArrowRight } from "react-icons/md";
import DynamicSVG from "../../components/dashboard/venue-table/dynmaic-svg";
import { useBlogs } from '../../hooks/blogs';
import ChangeStatusConfirmationDialog from '../../components/dialog/change-status';
import { changeStatus } from '../../api/blog';
import toast from "react-hot-toast";
import moment from 'moment';

const BlogList = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const { data: blogs, refetch } = useBlogs(currentPage, itemsPerPage);


useEffect(() => {
  refetch();
}, [currentPage, itemsPerPage])

const getStatusStyles = (status) => {
  if (status === "published") {
    return {
      backgroundColor: "#d1fae5",
      color: "#065f46",
    };
  } else {
    return {
      backgroundColor: "#fef3c7",
      color: "#92400e",  
    };
  }
};

const changeBlogStatus = (data) => {
  changeStatus(data?._id, { status: data?.status === "published" ? "draft": "published"}).then(resp => {
    if(resp?.message) toast.success(resp.message);
    else toast.error(resp?.error);
    setShowConfirmation(false);
    refetch();
  });
}


  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Blog List</h1>
        <Link
          to="/blogs/add"
          className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark"
        >
          + Add New Blog
        </Link>
      </div>
       <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 2 }}>
      <Table sx={{ minWidth: 650 }} aria-label="blogs table">
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f1f5f9" }}>
            <TableCell><strong>S.No</strong></TableCell>
            <TableCell><strong>Title</strong></TableCell>
            <TableCell><strong>Status</strong></TableCell>
            <TableCell><strong>Created At</strong></TableCell>
            <TableCell><strong>Updated At</strong></TableCell>
            <TableCell><strong>Actions</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            blogs?.data.map((customer, index) => (
              <TableRow
                key={index}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  '&:hover': { backgroundColor: "#f9fafb" },
                }}
              >
                <TableCell>{(currentPage - 1) * itemsPerPage + index + 1}</TableCell>
                <TableCell>
                  <div
                    // className="max-w-[200px] truncate"
                    title={customer?.title}
                  >
                    {customer?.title}
                  </div>
                </TableCell>
                <TableCell>
                  <Box
                    sx={{
                      ...getStatusStyles(customer?.status),
                      px: 2,
                      py: 0.5,
                      borderRadius: "12px",
                      display: "inline-block",
                      fontWeight: 500,
                      fontSize: "0.85rem",
                      textTransform: "capitalize"
                    }}
                  >
                    {customer?.status}
                  </Box>
                </TableCell>
                <TableCell>
                  { moment(customer?.createdAt).format("DD MMM YYYY, h:mm A") }
                </TableCell>
                <TableCell>
                    { moment(customer?.updatedAt).format("DD MMM YYYY, h:mm A") }
                </TableCell>
                <TableCell>
                  <div className='flex items-center space-x-3'>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      sx={{ textTransform: "none", borderRadius: 2 }}
                      onClick={() => navigate(`/blogs/${customer?.slug}`, { state: { blogId: customer?._id}})}
                    >
                      Preview
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      sx={{ textTransform: "none", borderRadius: 2 }}
                      onClick={() => {
                        setShowConfirmation(true);
                        setCurrentItem(customer);
                      }}
                    >
                      { customer?.status === "published" ? "Unpublish": "Publish"}
                    </Button>

                  </div>
                </TableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>

      {/* Pagination and items per page */}
      <Box className="flex justify-center items-center gap-6 py-4">
        <Typography>Page</Typography>
        <Box className="flex items-center space-x-3">
          <button
            onClick={() => setCurrentPage((prev) => prev - 1)}
            disabled={currentPage === 1}
            className={`disabled:opacity-50 ${currentPage === 1 ? "cursor-not-allowed" : ""}`}
          >
            <MdOutlineArrowLeft className="text-primary text-3xl" />
          </button>

          <Box className="min-w-[32px] h-[32px] flex bg-primary text-white justify-center items-center rounded-full">
            {currentPage}
          </Box>

          <button
            onClick={() => setCurrentPage((prev) => prev + 1)}
            disabled={currentPage === Math.ceil(blogs?.totalItems / itemsPerPage)}
            className={`disabled:opacity-50 ${currentPage === Math.ceil(blogs?.totalItems / itemsPerPage) ? "cursor-not-allowed" : ""}`}
          >
            <MdOutlineArrowRight className="text-primary text-3xl" />
          </button>
        </Box>

        <Select
          value={itemsPerPage}
          onChange={(e) => {
            setCurrentPage(1);
            setItemsPerPage(parseInt(e.target.value, 10));
          }}
          size="small"
        >
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={20}>20</MenuItem>
          <MenuItem value={30}>30</MenuItem>
        </Select>
      </Box>
    </TableContainer>
    <ChangeStatusConfirmationDialog isOpen={showConfirmation} onClose={() => {
      setShowConfirmation(false);
      setCurrentItem(null);
    }} onConfirm={() => changeBlogStatus(currentItem) }/>
    </div>
  );
};

export default BlogList;
